import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./ThankYou.css";

export default function ThankYou() {
	const navigate = useNavigate();

	useEffect(() => {
		setTimeout(() => {
			navigate("/");
		}, 5000);
	}, []);

	return (
		<div className="thank-you-page-wrapper">
			<h1>Благодарим ви!</h1>
			<p>Вашето съобщение беше изпратено, ще ви насочим към началната страница</p>
		</div>
	);
}
